<template>
  <b-container fluid>
    <ViewTitle title="Location Types and Locations" />
    <b-row>
      <b-col cols="12">
        <div>
          <b-button variant="success" @click.stop="addLocTypeForm()">Add Location Type</b-button>
        </div>
        <b-table fixed small :items="rows" :fields="fields">
          <template v-slot:cell(locTypeName)="row">
            <a href="#" @click.stop="editLocTypeForm(row.item.id)">{{ row.item.locTypeName }}</a>
          </template>
          <template v-slot:cell(locationName)="row">
            <a href="#" @click.stop="editLocationForm(row.item.id)">{{ row.item.locationName }}</a>
          </template>
          <template v-slot:cell(actions)="row">
            <b-badge
              v-if="row.item.isLocType"
              href="#"
              variant="warning"
              @click.stop="editLocTypeForm(row.item.id)"
            >Edit</b-badge>
            <b-badge
              v-if="row.item.isLocType"
              href="#"
              variant="danger"
              @click.stop="deleteLocTypeForm(row.item.id)"
            >Delete</b-badge>
            <b-badge
              v-if="row.item.isLocType"
              href="#"
              variant="success"
              @click.stop="addLocationForm(row.item.id)"
            >Add Location</b-badge>
            <b-badge
              v-if="!row.item.isLocType"
              href="#"
              variant="warning"
              @click.stop="editLocationForm(row.item.id)"
            >Edit</b-badge>
            <b-badge
              v-if="!row.item.isLocType"
              href="#"
              variant="danger"
              @click.stop="deleteLocationForm(row.item.id)"
            >Delete</b-badge>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <!-- Edit LocationType Modal -->
    <b-modal
      id="editLocationTypeModal"
      @ok="processLocTypeForm"
      ref="modallocationtype"
      :title="modalTitle"
    >
      <form @submit.stop.prevent="processLocTypeForm">
        <div class="modal-body">
          <div v-if="message" class="form-group">
            <div class="alert alert-warning">{{ message }}</div>
          </div>
          <div class="form-group">
            <label for="name" id="label_name">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              autofocus
              placeholder="Enter Name"
              v-model="currentLocType.name"
              required="required"
            />
          </div>
        </div>
      </form>
    </b-modal>
    <!-- End of edit LocationType modal -->

    <!-- Delete LocType modal -->
    <b-modal
      id="deleteLocTypeModal"
      @ok="deleteLocType"
      ref="deleteLocTypeModal"
      :title="modalTitle"
    >
      <div>
        Do you want to delete Location Type
        <strong>{{currentLocType.name}}</strong>?
      </div>
    </b-modal>

    <!-- Edit Location Modal -->
    <b-modal
      id="editLocationModal"
      @ok="processLocationForm"
      ref="modalLocation"
      :title="modalTitle"
    >
      <form @submit.stop.prevent="processLocationForm">
        <div class="modal-body">
          <div v-if="message" class="form-group">
            <div class="alert alert-warning">{{ message }}</div>
          </div>
          <div class="form-group">
            <label for="name" id="label_name">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              autofocus
              placeholder="Enter Name"
              v-model="currentLocation.name"
              required="required"
            />
          </div>
          <div class="form-group">
            <label for="reference" id="label_reference">Reference</label>
            <input
              type="text"
              class="form-control"
              id="reference"
              placeholder="Enter Reference"
              v-model="currentLocation.reference"
            />
          </div>
          <div class="form-group">
            <label for="longitude" id="label_longitude">Longitude</label>
            <input
              type="number"
              class="form-control"
              id="longitude"
              placeholder="Enter Longitude"
              v-model="currentLocation.longitude"
            />
          </div>
          <div class="form-group">
            <label for="latitude" id="label_latitude">Latitude</label>
            <input
              type="number"
              class="form-control"
              id="latitude"
              placeholder="Enter Latitude"
              v-model="currentLocation.latitude"
            />
          </div>
        </div>
      </form>
    </b-modal>
    <!-- End of edit Location modal -->
    <!-- Delete Location modal -->
    <b-modal
      id="deleteLocationModal"
      @ok="deleteLocation"
      ref="deleteLocationModal"
      :title="modalTitle"
    >
      <div>
        Do you want to delete Location
        <strong>{{currentLocation.name}}</strong>?
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import Location from '@/api/Location'
import LocType from '@/api/LocationType'

export default {
  name: 'LocationView',
  components: {
    ViewTitle,
  },
  cache: false,
  data: function() {
    return {
      loading: false,
      message: null,
      modalTitle: '',
      currentLocation: {},
      locTypes: [],
      locations: [],
      currentLocType: {},
      rows: [],
      fields: [
        { key: 'locTypeName', label: 'Location Type' },
        { key: 'locationName', label: 'Location' },
        { key: 'reference' },
        { key: 'lon' },
        { key: 'lat' },
        { key: 'actions' },
      ],
    }
  },

  computed: {
    ...mapGetters(['sitePath']),
  },

  mounted: function() {
    this.getLocData()
  },

  methods: {
    // LocTypes FORM methods
    // Add
    addLocTypeForm() {
      this.currentLocType = {}
      this.modalTitle = `Add new Location Type`
      this.$refs.modallocationtype.show()
    },
    // Edit
    editLocTypeForm(id) {
      LocType.get(this.sitePath, id)
        .then(response => {
          this.currentLocType = response
          this.modalTitle = `Edit Location Type #${id}`
          this.$refs.modallocationtype.show()
        })
        .catch(err => {
          console.log(err)
        })
    },
    // Delete
    deleteLocTypeForm(id) {
      LocType.get(this.sitePath, id)
        .then(response => {
          this.currentLocType = response
          this.modalTitle = `Delete Location Type #${id}`
          this.$refs.deleteLocTypeModal.show()
        })
        .catch(err => {
          console.log(err)
        })
    },

    // Process ADD & EDIT
    processLocTypeForm(evt) {
      if (evt) evt.preventDefault()
      // check if id already exists
      if (this.currentLocType.id !== undefined) {
        this.updateLocType(this.currentLocType.id)
      } else {
        this.addLocType()
      }
    },
    // API calling methods
    // Add / Post
    addLocType() {
      this.message = ''
      LocType.post(this.sitePath, this.currentLocType)
        .then(() => {
          this.getLocData()
          this.$refs.modallocationtype.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    // Edit / Update
    updateLocType(id) {
      this.message = ''
      LocType.put(this.sitePath, id, this.currentLocType)
        .then(() => {
          this.loading = false
          this.getLocData()
          this.$refs.modallocationtype.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    // Delete
    deleteLocType() {
      LocType.delete(this.sitePath, this.currentLocType.id)
        .then(response => {
          this.getLocData()
          this.$refs.deleteLocTypeModal.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    // Locations FORM methods
    // Add
    addLocationForm(id) {
      this.currentLocation = { location_type: id }
      this.modalTitle = `Add new Location`
      this.$refs.modalLocation.show()
    },
    // Edit
    editLocationForm(id) {
      Location.get(this.sitePath, id)
        .then(response => {
          this.currentLocation = response
          this.modalTitle = `Edit Location #${id}`
          this.$refs.modalLocation.show()
        })
        .catch(err => {
          console.log(err)
        })
    },
    // Delete
    deleteLocationForm(id) {
      Location.get(this.sitePath, id)
        .then(response => {
          this.currentLocation = response
          this.modalTitle = `Delete Location #${id}`
          this.$refs.deleteLocationModal.show()
        })
        .catch(err => {
          console.log(err)
        })
    },

    // Process ADD & EDIT
    processLocationForm(evt) {
      if (evt) evt.preventDefault()
      // check if id already exists
      if (this.currentLocation.id !== undefined) {
        this.updateLocation(this.currentLocation.id)
      } else {
        this.addLocation()
      }
    },

    // API calling methods
    // Add / Post
    addLocation() {
      this.message = ''
      Location.post(this.sitePath, this.currentLocation)
        .then(() => {
          this.getLocData()
          this.$refs.modalLocation.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    // Edit / Update
    updateLocation(id) {
      this.message = ''
      Location.put(this.sitePath, id, this.currentLocation)
        .then(() => {
          this.getLocData()
          this.$refs.modalLocation.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    // Delete
    deleteLocation() {
      Location.delete(this.sitePath, this.currentLocation.id)
        .then(response => {
          this.getLocData()
          this.$refs.deleteLocationModal.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    getLocations() {
      Location.getAll(this.sitePath)
        .then(data => {
          this.locations = data.results
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * Fetch LocType and Location data on 2 API calls
     * like calling getLocations() && getLocTypes() in 1 single shot
     */
    getLocData() {
      LocType.getAll(this.sitePath)
        .then(data => {
          this.locTypes = data.results
          Location.getAll(this.sitePath)
            .then(data => {
              this.locations = data.results
              this.buildRows()
            })
            .catch(err => {
              console.log(err)
            })
        })
        .catch(err => {
          console.log(err)
        })
    },

    /**
     * Builds a unique list of locationTypes and locations.
     */
    buildRows() {
      var locTypes = this.locTypes.map(loc => ({
        id: loc.id,
        isLocType: true,
        locationName: null,
        locType: loc.id,
        locTypeName: loc.name,
        lon: null,
        lat: null,
        reference: null,
        site: loc.site,
      }))

      const locations = this.locations.map(loc => ({
        id: loc.id,
        isLocType: false,
        locationName: loc.name,
        locType: loc.location_type,
        locTypeName: null,
        lon: loc.longitude,
        lat: loc.latitude,
        reference: loc.reference,
        site: loc.site,
      }))

      this.rows = locTypes.concat(locations)

      this.rows.sort((a, b) =>
        // Sort by locType id asc
        a.locType > b.locType
          ? 1
          : // If sane locType
          a.locType === b.locType
          ? //sort by isLocType, true first
            a.isLocType
            ? -1
            : 1
          : -1,
      )
    },
  },
}
</script>
